import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScGameRest implements ICommand
{

	public HostID : number = 0;
	public OnOrOff : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.OnOrOff = ba.readUint8();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		ba.writeUint8(this.OnOrOff);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScGameRest();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'OnOrOff(B)='+this.OnOrOff+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30017;
	}

	public getCmdName() : string
	{
		return 'ScGameRest';
	}

}
